import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import listProduct from '../components/product.json'
import ProductSingle from "../components/product";
import HeaderSection from "../components/head-section-two";
const ShopSingle = (props) =>{
    document.body.style.backgroundColor = "white"
    let color = [
        {
            name:"Black",
            number:"100"
        },
        {
            name:"Blue",
            number:"100"
        },
        {
            name:"Green",
            number:"100"
        },
        {
            name:"Turquoise",
            number:"100"
        },
        {
            name:"Brown",
            number:"100"
        }
    ]
    let brand = [
        {
            name:"Acerbis",
            number:"(100)"
        },
        {
            name:"Antoniolupi",
            number:"(100)"
        },
        {
            name:"Birex",
            number:"(100)"
        },
        {
            name:"Capod'opera",
            number:"(100)"
        },
        {
            name:"DelightFull",
            number:"(100)"
        },

        {
            name:"Eichholtz",
            number:"(100)"
        },
        {
            name:"Flamant",
            number:"(100)"
        }
    ]
    let price = [
        {
            name:"Under $100",
            under:"100",
            number:"(100)"
        },
        {
            name:"$100-$500",
            under:"400",
            number:"(100)"
        },
        {
            name:"$500-$100",
            under:"500",
            number:"(100)"
        },
        {
            name:"$1000-$1500",
            under:"1000",
            number:"(100)"
        }
    ]
    let material = [
        {
            name:" Cotton",
            number:"(100)"
        },
        {
            name:" Silk",
            number:"(100)"
        },
        {
            name:"Wool",
            number:"(100)"
        },
        {
            name:"Fabric",
            number:"(100)"
        },
        {
            name:"Leather",
            number:"(100)"
        },
    ]
    return (
        <div>
            <Header />
               <HeaderSection 
               title={props.location.state.name} 
               smallTitle={`Home / ${props.location.state.name}  /`} 
               usmallTitle="Get Your Product"
               />
               <section id="section_shop">
                   <div className="row col-12">
                        <div className="col-sm-3" id="left_side_shop">
                            <div id="categories_div_shop">
                                <p id="categories_div_shop_title">
                                 Categories
                                </p>
                                <hr id="line_shop"/>
                                <ul id="categories_div_shop_list">
                                <li>Couches <u>(863)</u> </li>
                                <li>Chairs and Benches <u>(717)</u></li>
                                <li>Stools <u>(457)</u></li>
                                <li>Side Tables <u>(656)</u></li>
                                <li>Coffee Tables <u>(1515)</u></li>
                                <li>Bookshelves and Shelves Unit <u>(219)</u></li>
                                <li>Madie and Cabinets <u>(368)</u></li>
                                <li>Shelves <u>(399)</u></li>
                                <li>TV Stands <u>(790)</u></li>
                                <li>Armchairs and Chaises Longues<u>(242)</u></li>
                                <li>Ottomans & Stools <u>(166)</u></li>
                                <li>Tables <u>(225)</u></li>
                                </ul>
                            </div>
                            <div id="categories_div_shop">
                                <p id="categories_div_shop_title">
                                 Color
                                </p>
                                <hr id="line_shop"/>
                                <ul id="categories_div_shop_list">
                                    <li>
                                 
                                        {
                                            color.map((v,k)=>{
                                                return(
                                                    <li key={k}>
                                                    <div className="row col-12">
                                                        <div className="col-2">
                                                        <input type="checkbox" id="color_checkBox" name="color"  value={v.name} />
                                                        </div>
                                                        <div className="col">
                                                        <label  id="name_color">{v.name} ({v.number})</label>
                                                        </div>
                                                    </div>
                                                    </li>
                                                )
                                            })
                                        }       
                                    </li>
                                </ul>
                            </div>
                            <div id="categories_div_shop">
                                <p id="categories_div_shop_title">
                                    Brand
                                </p>
                                <hr id="line_shop"/>
                                <ul id="categories_div_shop_list">
                                    <li>
                                 
                                        {
                                            brand.map((v,k)=>{
                                                return(
                                                    <li key={k}>
                                                    <div className="row col-12">
                                                        <div className="col-2">
                                                        <input type="checkbox" id="color_checkBox" name="brand"  value={v.name} />
                                                        </div>
                                                        <div className="col">
                                                        <label  id="name_color">{v.name} {v.number}</label>
                                                        </div>
                                                    </div>
                                                    </li>
                                                )
                                            })
                                        }       
                                    </li>
                                </ul>
                            </div>
                            <div id="categories_div_shop">
                                <p id="categories_div_shop_title">
                                    Price
                                </p>
                                <hr id="line_shop"/>
                                <ul id="categories_div_shop_list">
                                    <li>
                                 
                                        {
                                            price.map((v,k)=>{
                                                return(
                                                    <li key={k}>
                                                    <div className="row col-12">
                                                        <div className="col-2">
                                                        <input type="checkbox" id="color_checkBox" name="Price"  value={v.under} />
                                                        </div>
                                                        <div className="col">
                                                        <label  id="name_color">{v.name} {v.number}</label>
                                                        </div>
                                                    </div>
                                                    </li>
                                                )
                                            })
                                        }       
                                    </li>
                                </ul>
                            </div>
                            <div id="categories_div_shop">
                                <p id="categories_div_shop_title">
                                Material
                                </p>
                                <hr id="line_shop"/>
                                <ul id="categories_div_shop_list">
                                    <li>
                                 
                                        {
                                            material.map((v,k)=>{
                                                return(
                                                    <li key={k}>
                                                    <div className="row col-12">
                                                        <div className="col-2">
                                                        <input type="checkbox" id="color_checkBox" name="material"  value={v.name} />
                                                        </div>
                                                        <div className="col">
                                                        <label  id="name_color">{v.name} {v.number}</label>
                                                        </div>
                                                    </div>
                                                    </li>
                                                )
                                            })
                                        }       
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <div id="grid_3_system_img">
                                {
                                    listProduct.map((v,k)=>{
                                        return (
                                            <ProductSingle key={k} data={v}/>
                                        )
                                    })
                                }                      
                            </div>
                            <hr id="line_grid_3_system_img"/>
                        </div>
                   </div>
               </section>
            <Footer />
        </div>
    )
}
export default ShopSingle;
